/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OccupationCostForecastYearApiModel } from './occupationCostForecastYearApiModel';
import { OccupationCostForecastCapabilityApiModel } from './occupationCostForecastCapabilityApiModel';
import { OccupationCostForecastExaminationApiModel } from './occupationCostForecastExaminationApiModel';


export interface OccupationCostForecastOccupationApiModel { 
    occupationId: number;
    occupationName: string;
    employeeCount: number;
    initialOrderCost: number;
    initialOrderCapabilities: Array<OccupationCostForecastCapabilityApiModel>;
    initialOrderExaminations: Array<OccupationCostForecastExaminationApiModel>;
    years: Array<OccupationCostForecastYearApiModel>;
}

